import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Box, Container, Typography } from '@mui/material';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import React, { useEffect, useState } from 'react';
import FullsteamLogo from '../../Assets/fullsteam_logo.png';

interface SidebarProps {
    title?: string;
    logo?: string;
    alt?: string;
    showPanel?: boolean;
    children?: React.ReactNode;
}

const Sidebar = ({ title, logo, alt, showPanel = true, children }: SidebarProps) => {
    const mobileWidth: number = 900;
    const [isExpanded, setIsExpanded] = useState(window.innerWidth >= mobileWidth);

    useEffect(() => {
        const debounce = (func: Function, wait: number) => {
            let timeout: NodeJS.Timeout;
            return (...args: any[]) => {
                clearTimeout(timeout);
                timeout = setTimeout(() => func(...args), wait);
            };
        };

        const handleResize = debounce(() => {
            if (window.innerWidth >= mobileWidth)
                setIsExpanded(true);
        }, 100);

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const handleAccordionChange = (event: React.SyntheticEvent, newExpanded: boolean) => {
        if (window.innerWidth >= mobileWidth) {
            setIsExpanded(true);
        } else {
            setIsExpanded(newExpanded);
        }
    };

    const logoElement = logo ?
        <Box className="logo">
            <img id="business-unit-logo-image" data-test-id="business-unit-logo-image" src={`data:image/png;base64,${logo}`} alt={alt} />
        </Box> : <Box />

    const panelElement = showPanel ?
        <Accordion expanded={isExpanded} onChange={handleAccordionChange} className="container accordian" data-test-id="sidebar-collapsable-accordion">
            <AccordionSummary className="accordian-summary" expandIcon={<span className={'primary-icon'} data-test-id="sidebar-expand-collapse-button" ><ExpandMoreIcon /></span>}>
                <Typography variant="h5" component="h3" data-test-id="sidebar-header-text" gutterBottom>
                    {title}
                </Typography>
            </AccordionSummary>
            <AccordionDetails>
                {children}
            </AccordionDetails>
        </Accordion> : <></>

    return (

        <Box id="sidebar">
            <Container className="container center-container" id="logoContainer">
                <Box className="center-item">
                    <Box className="logo">
                        <img alt="Fullsteam logo" data-test-id="fullsteam-logo-image" src={FullsteamLogo} />
                    </Box>
                    {logoElement}
                </Box>
            </Container>
            {panelElement}
        </Box>
    );
}

export default Sidebar;